import { CircleHelp } from "lucide-react";
import { Link, useLocation } from "react-router";
import { Button } from "@/shared/ui/Button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/Tooltip";
import { findHelpPageLink } from "../configs/helpPages";

/**
 * Bouton d'aide de la barre du haut, à gauche des suggestions. Affiché
 * uniquement sur les pages couvertes par un guide.
 */
const HelpButton = () => {
  const { pathname, search } = useLocation();
  const link = findHelpPageLink(pathname);
  if (!link) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button asChild variant="outline" size="icon" className="size-7">
          <Link to={link.path} state={{ from: `${pathname}${search}` }} aria-label={link.label}>
            <CircleHelp />
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{link.label}</TooltipContent>
    </Tooltip>
  );
};

export default HelpButton;
